import { useWorkspaceAsset } from '@gripp/shared-logic';
import { LoadingIndicator } from '@gripp/shared-ui';
import { useParams } from 'react-router-dom';
import { AnonymousAsset } from './anonymousAsset';

/**
 * `/anonymous/assets/:assetId` — mobile's `anonymous/assets/[assetId]` ported.
 * Reached from the asset link on a signed-out share view; the QR flow keeps
 * arriving through `/:tagId`. The asset read runs as the Anonymous account
 * exactly as it does for a scanned tag, so no share token is involved and
 * browser back returns to the conversation.
 */
export const AnonymousAssetById = () => {
  const { assetId } = useParams<{ assetId: string }>();
  const { workspaceAsset, isLoading } = useWorkspaceAsset(
    assetId ?? '',
    !assetId
  );

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!workspaceAsset?.asset) {
    return null;
  }

  return <AnonymousAsset asset={workspaceAsset.asset} tagCode="" />;
};
